import type { EquipeDialogProps } from "./types-equipe-dialog";

export function useEquipeDialog({ testId }: EquipeDialogProps) {
  return {
    testIds: { voltar: `${testId}-voltar`, confirmar: `${testId}-confirmar` },
  };
}
